import { api } from '../api/axios'

// Etapa vigente do campeonato (rota publica /publico/etapa-vigente): a primeira
// etapa que ainda nao terminou, ou a ultima se todas ja terminaram. Inscricao,
// Inscritos e Resultados publicos mostram so ela; as anteriores ficam na TV Online.
export interface EtapaVigente {
  numero_etapa: number | null
  data_inicio?: string
  data_encerramento?: string
}

export async function buscarEtapaVigente(idcampeonato: number): Promise<EtapaVigente> {
  const r = await api.get<EtapaVigente>(`/publico/etapa-vigente?idcampeonato=${idcampeonato}`)
  return r.data
}

// "30/10/2026 a 02/11/2026"
export function periodoEtapa(e: EtapaVigente | null): string {
  if (!e?.data_inicio || !e.data_encerramento) return ''
  const f = (d: string) => new Date(d).toLocaleDateString('pt-BR')
  return `${f(e.data_inicio)} a ${f(e.data_encerramento)}`
}
